import PropTypes from 'prop-types';
import { useState } from 'react';

const ChallengeQuestions = ({ questions = [] }) => {
	const [question1, setQuestion1] = useState(-1);
	const [question2, setQuestion2] = useState(-1);
	const [question3, setQuestion3] = useState(-1);

	const questionSet1 = questions.filter(
		({ id }) => id != question2 && id != question3,
	);
	const questionSet2 = questions.filter(
		({ id }) => id != question1 && id != question3,
	);
	const questionSet3 = questions.filter(
		({ id }) => id != question1 && id != question2,
	);

	return (
		<>
			<div className="form-control">
				<label htmlFor="question1" className="label label-text">
					Question 1
				</label>
				<select
					id="question1"
					name="question1"
					required
					className="select select-bordered select-sm"
					onChange={({ target }) => setQuestion1(target.value)}
					value={question1}
				>
					<option value={-1}>Choose...</option>
					{questionSet1.map(({ id, question }) => (
						<option key={`${id}`} value={id}>
							{question}
						</option>
					))}
				</select>
			</div>
			<div className="form-control">
				<label htmlFor="answer1" className="label label-text">
					Answer 1
				</label>
				<input
					id="answer1"
					name="answer1"
					type="text"
					required
					className="input input-sm input-bordered"
				/>
			</div>
			<div className="form-control">
				<label htmlFor="question2" className="label label-text">
					Question 2
				</label>
				<select
					id="question2"
					name="question2"
					required
					className="select select-bordered select-sm"
					onChange={({ target }) => setQuestion2(target.value)}
					value={question2}
				>
					<option value={-1}>Choose...</option>
					{questionSet2.map(({ id, question }) => (
						<option key={`${id}`} value={id}>
							{question}
						</option>
					))}
				</select>
			</div>
			<div className="form-control">
				<label htmlFor="answer2" className="label label-text">
					Answer 2
				</label>
				<input
					id="answer2"
					name="answer2"
					type="text"
					required
					className="input input-sm input-bordered"
				/>
			</div>
			<div className="form-control">
				<label htmlFor="question3" className="label label-text">
					Question 3
				</label>
				<select
					id="question3"
					name="question3"
					required
					className="select select-bordered select-sm"
					onChange={({ target }) => setQuestion3(target.value)}
					value={question3}
				>
					<option value={-1}>Choose...</option>
					{questionSet3.map(({ id, question }) => (
						<option key={`${id}`} value={id}>
							{question}
						</option>
					))}
				</select>
			</div>
			<div className="form-control">
				<label htmlFor="answer3" className="label label-text">
					Answer 3
				</label>
				<input
					id="answer3"
					name="answer3"
					type="text"
					required
					className="input input-sm input-bordered"
				/>
			</div>
		</>
	);
};

ChallengeQuestions.propTypes = {
	questions: PropTypes.arrayOf(PropTypes.object),
};

export default ChallengeQuestions;
